<lib-spinner
  *ngIf="(selectAppInitialization$ | async).initializing"
></lib-spinner>
<router-outlet
  myBillAnalyticsNavigation
  [attr.deployedVersion]="version"
></router-outlet>
<ng-template #loadBundledTranslationsComponent></ng-template>
